#
# jQuery Remote Modal Plugin
#
# Usage:
#   <a href="somepage.html" data-remote-modal="true">Show Modal</a>
#
#   <a href="#some-id" data-remote-modal="true">Show Modal</a>
#
$ = jQuery

# The powerhouse main class
class RemoteModal
  MODAL_MARGIN = 10

  constructor: (@el, settings) ->
    # Load in the settings
    @settings =
      zIndex: 9999
      showBackdrop: true

    $.extend @settings, settings

    # Cancellable things
    @activeRequest = null

    # Element references
    @modal = null

    # Destroy modal when escape key is pressed
    $(document).keyup (e) =>
      @close() if e.keyCode == 27

    # Trigger a modal resize if the window size changes
    $(window).resize =>
      @resize()

  toggle: ->
    if $("#remote-modal-backdrop").length
      @close()
    else
      @open()

  open: ->
    $body = $("body")

    #TEMP add blur to content
    $("#content").addClass("blur")

    # Never allow multiple backdrops or modals
    @close()

    # Work out how we are going to load the data
    source = @el.attr("href") || @el.data("href")
    localData = (source.charAt(0) == "#")

    # Create and show the backdrop
    if @settings.showBackdrop
      $backdrop = $("<div id='remote-modal-backdrop'>")
        .addClass("fade")
        .css
          width: "100%"
          height: "100%"
          position: "fixed"
          top: 0
          left: 0
          zIndex: @settings.zIndex
        .click =>
          @close()
        .appendTo($body)
        .addClass("in")

    # Create the modal
    # TODO:JS Make the css customizable
    @modal = $("<div id='remote-modal'>")
      .addClass("fade")
      .css
        zIndex: @settings.zIndex + 2
        position: "fixed"
        top: "50%"
        left: "50%"
        maxWidth: $(window).width() - MODAL_MARGIN
        maxHeight: $(window).height() - MODAL_MARGIN
        overflow: "auto"

    # Load the modal's contents
    if localData
      content = $(source).clone()
      @fill(content)
    else
      self = this
      @request = $.ajax
        url: source
        type: @el.attr("data-method") || "GET"

        success: (data) =>
          # TODO: Fix flash in webkit transition
          @fill(data)

        error: =>
          @modal.html("Could not load page")

  fill: (content) ->
    @modal
      .appendTo($("body"))
      .html(content)
      .css({
        marginTop: (@modal.outerHeight() / 2) * -1
        marginLeft: (@modal.outerWidth() / 2) * -1
      })
      .addClass("in")

    @modal.find("[data-close-modal]").click (e) =>
      @close()
      e.preventDefault()

    @el.trigger("remote-modal:shown", @)

  close: () ->

    #TEMP add blur to content
    $("#content").addClass("blur")

    $("#remote-modal-backdrop, #remote-modal").removeWithFade()

    # Clear references
    @modal = null

    if @request
      @request.abort()
      @request = null

  resize: ->
    if @modal and @modal.length
      # Adjust the max width/height
      @modal.css
        maxWidth: $(window).width() - MODAL_MARGIN
        maxHeight: $(window).height() - MODAL_MARGIN

      # Adjust the margins based on new modal size
      @modal.css
        marginTop: (@modal.outerHeight() / 2) * -1
        marginLeft: (@modal.outerWidth() / 2) * -1


# Connect the modal to jquery click event
$.fn.remoteModal = (settings) ->
  $(this).each ->
    if !$(this).data('modal-enabled')
      modal = new RemoteModal $(this), settings
      $(this).data('modal-enabled', true)

      $(this).click ->
        modal.toggle()
        false
